import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "static-banner-wrapper" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "static-banner" };
const _hoisted_4 = { class: "banner-products" };
const _hoisted_5 = ["src"];
import { useAssets } from '../composables/useAssets';
export default /*@__PURE__*/ _defineComponent({
    __name: 'StaticBanner',
    setup(__props) {
        const { assetUrl } = useAssets();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "banner-content" }, [
                            _createElementVNode("h2", { class: "banner-title" }, [
                                _createTextVNode(" THE ORIGINAL"),
                                _createElementVNode("br"),
                                _createTextVNode(" BRITISH MOTOR OIL"),
                                _createElementVNode("br"),
                                _createTextVNode(" SINCE 1899 ")
                            ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("img", {
                                src: _unref(assetUrl)('/images/trade-site/oil-bottles.png'),
                                alt: ""
                            }, null, 8, _hoisted_5)
                        ])
                    ])
                ])
            ]));
        };
    }
});
